import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState: number = (window as any).pageId;

const pageIdSlice = createSlice({
    name: 'page-id-slice',
    initialState,
    reducers: {
    },
})

export default pageIdSlice;